import OrdersSection from '@/sections/izzi/orders/orders-section';

export default function OrdersPage() {
  return <OrdersSection />;
}
